/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportForDeviceVersionHistoryElementResponse
 */
export interface ReportForDeviceVersionHistoryElementResponse {
    /**
     * 
     * @type {Date}
     * @memberof ReportForDeviceVersionHistoryElementResponse
     */
    changedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceVersionHistoryElementResponse
     */
    loaderVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceVersionHistoryElementResponse
     */
    firmwareVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceVersionHistoryElementResponse
     */
    uiVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceVersionHistoryElementResponse
     */
    customFirmware1Version: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceVersionHistoryElementResponse
     */
    customFirmware2Version: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceVersionHistoryElementResponse
     */
    customFirmware3Version: string | null;
}

export function ReportForDeviceVersionHistoryElementResponseFromJSON(json: any): ReportForDeviceVersionHistoryElementResponse {
    return ReportForDeviceVersionHistoryElementResponseFromJSONTyped(json, false);
}

export function ReportForDeviceVersionHistoryElementResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceVersionHistoryElementResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'changedAt': (json['changedAt'] === null ? null : new Date(json['changedAt'])),
        'loaderVersion': json['loaderVersion'],
        'firmwareVersion': json['firmwareVersion'],
        'uiVersion': json['uiVersion'],
        'customFirmware1Version': json['customFirmware1Version'],
        'customFirmware2Version': json['customFirmware2Version'],
        'customFirmware3Version': json['customFirmware3Version'],
    };
}

export function ReportForDeviceVersionHistoryElementResponseToJSON(value?: ReportForDeviceVersionHistoryElementResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'changedAt': (value.changedAt === null ? null : value.changedAt.toISOString()),
        'loaderVersion': value.loaderVersion,
        'firmwareVersion': value.firmwareVersion,
        'uiVersion': value.uiVersion,
        'customFirmware1Version': value.customFirmware1Version,
        'customFirmware2Version': value.customFirmware2Version,
        'customFirmware3Version': value.customFirmware3Version,
    };
}

